<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>
			<v-card>
				<v-card-text class="text-h5 text-center pa-4">طرق الدفع للنقل ببديل</v-card-text>
				<v-card-text>
					<v-row>
						<v-col cols="12" class="pa-2">
							<v-textarea
								v-model="terms"
								:rows="5"
								outlined
								hide-details="auto"
								label="طرق الدفع للنقل ببديل"
								:loading="loading"
							></v-textarea>
						</v-col>
						<v-col cols="12" class="text-center">
							<v-btn color="success" :disabled="loading" :loading="submitting" @click="saveTerms">حفظ</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-container>
	</div>
</template>

<script>
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'النقل ببديل', exact: true, to: { name: "dashboard-replacement" } },
				{ text: 'الإقرار', disabled: true }
			],
			terms: null,
			loading: true,
			submitting: false
		};
	},
	mounted() {
		this.getTerms();
	},
	methods: {
		getTerms() {
			client
				.get("/api/replacements/payment")
				.then(response => {
					this.loading = false;
					this.terms = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		saveTerms() {
			var data = {
				replacementPaymentMessages: this.terms
			};
			this.submitting = true;

			clientNotifier
				.post("/api/replacements/updatepayment", data)
				.then(response => {
					this.submitting = false;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		}
	}
};
</script>